export default {
  theme: (state) => state.theme,
  clubVersion: (state) => state.clubVersion,
  isMobile: (state) => state.isMobile,
  isLoading: (state) => state.initLoading,
  getGlobalSettings:(state) => state.globalSettings
};